// @flow
export default (a: boolean = false, b: boolean = false, desc: boolean = true) =>
  desc ? Number(b) - Number(a) : Number(a) - Number(b)
